import React, { useState, useEffect } from 'react'
import { Button } from '../../../lib/ui/button'
import AylaResponseScrollArea from '../../ShortCourses/AylaResponseScrollArea'
import { useAiResponseStream } from './useAiResponseStream'
import { useTranslation } from '../../../hooks/useTranslation'
import AylaLoading from '~/components/shared/AylaLoading'
import AylaTimeoutError from '~/components/shared/AylaTimeout'
import Modal from '~/components/_layouts/Modal/index'
import StarFeedback from '../../shared/StarFeedback'

export default function SkillsMatchModal({ showDialog, toggleDialog, job }) {
  const { t } = useTranslation('SkillsMatchButton')
  const {
    aiResponse,
    setAiResponse,
    setTargetJob,
    aiStreamComplete,
    setAiStreamComplete,
    aiFailed,
    retryStream,
  } = useAiResponseStream()
  const [displayedText, setDisplayedText] = useState('')
  const [index, setIndex] = useState(0)
  const showCursor = displayedText.length <= 0
  useEffect(() => {
    if (showDialog) {
      setAiResponse('')
      setAiStreamComplete(false)
      setDisplayedText('')
      setIndex(0)
      setTargetJob(job)
    }
  }, [showDialog, setAiStreamComplete, setTargetJob, job, setAiResponse])

  return (
    <Modal
      title={t('ask_ayla')}
      open={showDialog}
      onClose={toggleDialog}
      size="lg"
      icon="ayla"
    >
      <div className="px-4 text-center">
        {!aiFailed &&
          (aiStreamComplete
            ? t('skills_match', { job_title: job.title })
            : t('ayla_working', { job_title: job.title }))}
        {aiFailed && (
          <AylaTimeoutError
            onRetry={() => {
              setDisplayedText('')
              setIndex(0)
              retryStream()
            }}
          />
        )}
        {!aiFailed && !aiResponse && (
          <div className="flex items-center justify-center">
            <AylaLoading />
          </div>
        )}
        {!aiFailed && aiResponse && (
          <AylaResponseScrollArea
            showBorder={true}
            showCursor={showCursor}
            aylaResponse={aiResponse}
            typingComplete={aiStreamComplete}
            setTypingComplete={setAiStreamComplete}
            displayedText={displayedText.replace(/\n/g, '<br>')}
            setDisplayedText={setDisplayedText}
            index={index}
            setIndex={setIndex}
            className="mb-4 h-64 text-left"
          ></AylaResponseScrollArea>
        )}
        {aiStreamComplete && (
          <div className="mb-4 flex flex-col items-center gap-2">
            <div>{t('rate_response')}</div>
            <StarFeedback
              path="/research_learning/ayla/feedback?feedback_type=Feedback::AylaSkillsMatch"
              jobPostingId={job?.id}
            />
          </div>
        )}
        <div className="mb-4 flex items-center justify-around gap-2">
          <a
            href={`/personal_brand/cover_letters/ai?use_skills_match=true&job_posting_id=${job.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={aiStreamComplete ? '' : 'invisible'}
          >
            <Button>{t('tailor_cover_letter')}</Button>
          </a>
          <Button
            className={aiResponse ? '' : 'invisible'}
            onClick={toggleDialog}
          >
            {t('close')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
